'use client'

import { cn } from '../../utils/cn'
import { ArrowRight } from 'lucide-react'

interface HeroCTA {
  text: string
  href: string
}

interface HeroMinimalProps {
  headline: string
  subheadline: string
  primaryCTA: HeroCTA
}

export function HeroMinimal({
  headline,
  subheadline,
  primaryCTA
}: HeroMinimalProps) {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center pt-24 pb-16">
      <div className="landing-container relative z-10">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto">
          {/* Headline */}
          <h1 className="headline-lg mb-6">
            {headline}
          </h1>

          {/* Subheadline */}
          <p className="body-lg max-w-readable mb-8">
            {subheadline}
          </p>

          {/* CTA */}
          <a
            href={primaryCTA.href}
            className={cn(
              'inline-flex items-center justify-center gap-2',
              'px-6 py-3 text-base font-medium rounded-lg',
              'bg-[var(--accent)] text-white',
              'hover:bg-[var(--accent-hover)]',
              'transition-all duration-200',
              'cta-glow'
            )}
          >
            {primaryCTA.text}
            <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  )
}
